import { numberToBRL, beautifyNumberToBRL } from 'commons/js/formatters/Currency';

const emptyProduct = {
  name: '',
  quantity: 0,
  unitary_value: 0,
};

export default function (maxProducts = 7) {
  return {
    props: {
      order: {
        type: Object,
        required: true,
      },
    },

    computed: {
      products() {
        const maxLength = maxProducts - this.order.products.length;
        const length = maxLength <= 0 ? 0 : maxLength;

        return this.order.products.concat(new Array(length).fill(emptyProduct)).slice(0, maxProducts);
      },

      totalQuantity() {
        return this.order.products.reduce((quantity, product) => quantity + product.quantity, 0);
      },

      totalValue() {
        return this.order.products.reduce((value, product) => value + product.unitary_value * product.quantity, 0);
      },

      totalWeight() {
        const totalWeight = this.order.products.reduce((weight, product) => weight + product.weight, 0);

        return totalWeight || this.order.weight || this.order.billed_weight;
      },
    },

    methods: {
      numberToBRL,
      beautifyNumberToBRL,
    },
  };
};